angular.module('bribac.services.updateRuleSetEditFormat', [
  'bribac.values'
])

  .factory('updateRuleSetEditFormat', function(
    state
  ) {
    return function updateRuleSetEditFormat(ruleSetInReadFormat) {
      var updated = angular.copy(ruleSetInReadFormat)
      updated.bacLimit.unit = state.currentAgent.organization.bacUnit
      updated.bacLimit.value = ruleSetInReadFormat.bacLimit[updated.bacLimit.unit]
      return updated
    }
  })
